import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-network-benefits',
  templateUrl: './network-benefits.component.html',
  styleUrls: ['./network-benefits.component.scss']
})
export class NetworkBenefitsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
